import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import StatsOverview from "./components/StatsOverview";
import FilterTabs from "./components/FilterTabs";
import PackageList from "./components/PackageList";
import DeleteModal from "./components/DeleteModal";
import { FaHeart, FaComment, FaEllipsisVertical, FaTrash } from "react-icons/fa6";
import { FaArrowUp, FaArrowDown, FaCrown, FaPause } from "react-icons/fa6";
import { FaEdit, FaTimes } from "react-icons/fa";
import { motion, useMotionValue, animate } from "framer-motion";
import ProfileService from "../../services/Profile";
import { useNavigate } from "react-router-dom";

export default function MySignals() {

    const [packages, setPackages] = useState([]);
    // const [packages2, setPackages2] = useState([]);
    const [filter, setFilter] = useState("all");
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [toDeletePackageId, setToDeletePackageId] = useState(null);
    const [allSignalsModal, setAllSignalsModal] = useState({ visible: false, signals: null });
const navigate = useNavigate();
    const [activeMenuId, setActiveMenuId] = useState(null);


    useEffect(() => {
        const getMyPackages = async () => {
            try {
                const res = await ProfileService.getMyPackages();
                console.log("my packages", res);
                setPackages(res?.data?.data);
            }
            catch (err) {
                console.error("Failed to fetch packages", err);
            }
        };
        getMyPackages();
    }, []);




    const filteredPackages = packages.filter((p) => {
        if (filter === "all") return true;
        if (filter === "active") return p.status === "Active";
        if (filter === "draft") return p.status === "pending";
        return true;
    });

    function handleBack() {
        window.history.back();
    }
    function handleShowStats() {navigate("/market")}
    function handleAddNew() { console.log("Add new package"); }
    function handleFilter(type) { setFilter(type); }

    function handleRequestDelete(packageId) {
        setToDeletePackageId(packageId);
        setDeleteModalVisible(true);
    }
    function handleCancelDelete() {
        setToDeletePackageId(null);
        setDeleteModalVisible(false);
    }
    function handleConfirmDelete() {
        if (!toDeletePackageId) return;
        setPackages(prev => prev.filter(p => p._id !== toDeletePackageId));
        setToDeletePackageId(null);
        setDeleteModalVisible(false);
    }

    function viewAllSignals(signals) { setAllSignalsModal({ visible: true, signals }); }
    function closeAllSignalsModal() { setAllSignalsModal({ visible: false, signals: null }); }


    const allSignalsList = (() => {
        if (!allSignalsModal.visible) return [];
        return allSignalsModal.signals;
    })();

    const y = useMotionValue(0);

    const handleCloseClick = () => {
        animate(y, 500, { duration: 0.4, ease: "easeInOut" });
        setTimeout(() => closeAllSignalsModal(), 400);
    };

    const handleDragEnd = (event, info) => {
        const swipeThreshold = 50;
        const velocity = info.velocity.y;
        
        if (info.offset.y > swipeThreshold || velocity > 500) {
            animate(y, 500, { duration: 0.3, ease: "easeInOut" });
            setTimeout(() => closeAllSignalsModal(), 300);
        } else {
            animate(y, 0, { duration: 0.2, ease: "easeOut" });
        }
    };

    return (
        <div className="font-sans bg-gray-50 min-h-screen">
            <Header onBack={handleBack} onShowStats={handleShowStats} onAddNew={handleAddNew} />
            <main id="main-content" className="pt-20 pb-24">
                {/* <StatsOverview /> */}
                <FilterTabs active={filter} onFilter={handleFilter} />

                <div className="px-4">
                    <PackageList packages={filteredPackages} onRequestDelete={handleRequestDelete} onViewAllSignals={viewAllSignals} />
                </div>
            </main>

            <DeleteModal visible={deleteModalVisible} onCancel={handleCancelDelete} onDelete={handleConfirmDelete} />

            {/* All Signals Modal */}
            {allSignalsModal.visible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
                    onClick={() => handleCloseClick()}
                >
                    <motion.div
                        drag="y"
                        dragElastic={0.1}
                        dragConstraints={{ top: 0, bottom: 0 }}
                        dragMomentum={true}
                        onDragEnd={handleDragEnd}
                        style={{ y }}
                        initial={{ y: 500 }}
                        animate={{ y: 0 }}
                        exit={{ y: 500 }}
                        transition={{ type: "spring", damping: 30, stiffness: 300 }}
                        className="fixed bottom-0 left-0 right-0 flex items-end justify-center z-50"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="bg-white rounded-t-3xl w-full max-h-[85vh] shadow-2xl">
                            <div className="p-4 border-b border-gray-100 flex items-center justify-between sticky top-0 bg-white rounded-t-3xl">
                                <div className="flex-1 flex justify-center">
                                    <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 absolute left-4">All Signals</h3>
                                <button onClick={handleCloseClick} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100">
                                    <FaTimes className="text-gray-600" />
                                </button>
                            </div>

                            <div className="overflow-y-auto max-h-[calc(85vh-60px)] p-4">
                                <div className="space-y-3">
                                    {allSignalsList.length === 0 && <p className="text-sm text-gray-500 text-center py-6">No signals available</p>}
                                    {allSignalsList.map((s, idx) => (
                                        <div key={`${s?._id}-${idx}`} className={`flex items-center justify-between p-3 bg-gray-50 rounded-lg`}>
                                            <div className="flex items-center space-x-3 flex-1">
                                                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`}>
                                                    <img src={`${"https://api.7-trade.ir/"}${s?.image?.path}`} alt={s.description} className="w-full h-full object-cover rounded-lg" />
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <p className="font-medium text-gray-900 truncate">{s.description}</p>
                                                    <p className="text-xs text-gray-500">{s.createdAt} • {s?.type === "sell" ? "SELL" : s?.type === "buy" ? "BUY" : "HOLD"}</p>
                                                </div>
                                            </div>
                                            <div className="flex gap-3 justify-center items-center flex-shrink-0 ml-3">
                                                <div className="text-right">
                                                    <p className={`font-semibold text-sm ${s?.delta === "Pending" ? "text-green-500" : "text-gray-500"}`}>{s?.delta ? s?.delta : "Pending"}</p>
                                                    <div className="flex items-center space-x-2 text-xs text-gray-500">
                                                        <span className="flex gap-1 items-center">
                                                            <FaHeart /> {s.likesCount || 0}
                                                        </span>
                                                        <span className="flex gap-1 items-center">
                                                            <FaComment /> {s.commentsCount || 0}
                                                        </span>
                                                    </div>
                                                </div>
                                                <SignalMenu
                                                    id={idx + 1}
                                                    activeMenuId={activeMenuId}
                                                    setActiveMenuId={setActiveMenuId}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
            
        </div>
    );
}

/* SignalMenu Component */
function SignalMenu({ id, activeMenuId, setActiveMenuId }) {
    const ref = React.useRef(null);

    React.useEffect(() => {
        function onDoc(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                setActiveMenuId(null);
            }
        }
        document.addEventListener("click", onDoc);
        return () => document.removeEventListener("click", onDoc);
    }, [setActiveMenuId]);

    const isOpen = activeMenuId === id;

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    setActiveMenuId(isOpen ? null : id);
                }}
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-white hover:bg-gray-100"
            >
                <FaEllipsisVertical className="text-gray-600" />
            </button>

            {isOpen && (
                <div className="absolute right-10 -top-8 w-36 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50">
                    <button
                        onClick={() => {
                            console.log("edit signal", id);
                            setActiveMenuId(null);
                        }}
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3"
                    >
                        <FaEdit className="text-blue-500 w-4" />
                        <span className="text-gray-700">Edit</span>
                    </button>
                    <button
                        onClick={() => {
                            console.log("delete signal", id);
                            setActiveMenuId(null);
                        }}
                        className="w-full px-4 py-2 text-left hover:bg-red-50 flex items-center space-x-3"
                    >
                        <FaTrash className="text-red-500 w-4" />
                        <span className="text-red-600">Delete</span>
                    </button>
                </div>
            )}
        </div>
    );
}
